import type { OpsCenterCopy } from "./OpsCenter.Types";
import { humanize } from "./i18n/OpsCenter.I18n";

export function actorRefLabel(ref: string | null | undefined, copy: OpsCenterCopy): string {
  if (!ref) {
    return copy.labels.notRecorded;
  }
  return copy.actorRefs?.[ref] ?? fallbackActorRefLabel(ref);
}

export function fallbackActorRefLabel(ref: string): string {
  const [, rawName] = ref.split(":", 2);
  return humanize((rawName || ref).replaceAll("-", "_"));
}
